import React from 'react';
import { Form } from 'antd';
import { Input } from 'antd-mobile';
import { createUseStyles } from 'react-jss'
import 'moment/locale/ru';

const useStyles = createUseStyles({
    Obj: {
        '&.am-list-item': {
            paddingLeft: "0px"
        },
        '&.am-list-item .am-list-line': {
            paddingRight: "0px"
        },
    },
    Time: {
        '&.am-list-item': {
            paddingLeft: "0px"
        },
    },
    Boolean: {
        '&.am-list-item': {
            paddingLeft: "0px"
        },
    },
    Float: {
        '&.am-list-item': {
            paddingLeft: "0px"
        },
    },
    Integer: {
        '&.am-list-item': {
            paddingLeft: "0px"
        },
    },
    String: {
        '&.am-list-item': {
            paddingLeft: "0px"
        },
        '& .am-textarea-control textarea': {
            textAlign: "end",
        },
    },
})

export default function SearchUser(props) {
    const classes = useStyles();
    const { form } = props;

    return (
        <div style={{ padding: "0px 10px" }}>
            <Form
                form={form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                    // shkolaID: object.ID
                }}
            >
                <Form.Item
                    name={"Email"}
                    label={"Email"}
                    rules={[{ required: true, message: 'Укажите email!' }]}
                >
                    <Input
                        className={classes.String}
                        placeholder={"введите email"}
                    />
                </Form.Item>
                <Form.Item
                    name={"Lastname"}
                    label={"Фамилия"}
                    rules={[{ required: true, message: 'Укажите фамилию!' }]}
                >
                    <Input
                        className={classes.String}
                        placeholder={"введите фамилию"}
                    />
                </Form.Item>
                <Form.Item
                    name={"Firstname"}
                    label={"Имя"}
                    rules={[{ required: true, message: 'Укажите имя!' }]}
                >
                    <Input
                        className={classes.String}
                        placeholder={"введите имя"}
                    />
                </Form.Item>
            </Form>
        </div>
    );
}
